import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus, Download, FileDown } from "lucide-react";
import { toast } from "sonner";

export default function Projects() {
  const [items, setItems] = useState([]);
  const nav = useNavigate();

  const load = async () => {
    const { data } = await api.get("/projects");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const del = async (id) => {
    if (!window.confirm("Silmek istediğinize emin misiniz?")) return;
    await api.delete(`/projects/${id}`);
    toast.success("Proje silindi");
    load();
  };

  const downloadFile = async (id, kind) => {
    const url = kind === "xlsx" ? `/projects/${id}/export/xlsx` : `/projects/${id}/customer-offer.pdf`;
    try {
      const res = await api.get(url, { responseType: "blob" });
      const cd = res.headers["content-disposition"] || "";
      const m = cd.match(/filename="?([^"]+)"?/);
      const filename = m ? m[1] : `teklif.${kind}`;
      const blob = new Blob([res.data]);
      const a = document.createElement("a");
      a.href = URL.createObjectURL(blob);
      a.download = filename;
      a.click();
      URL.revokeObjectURL(a.href);
      toast.success(kind === "xlsx" ? "Excel indirildi (14 sayfa)" : "PDF indirildi");
    } catch (e) {
      toast.error("İndirme başarısız");
    }
  };

  return (
    <div className="space-y-6" data-testid="projects-page">
      <div className="flex items-end justify-between">
        <div>
          <div className="text-xs uppercase tracking-widest text-muted-foreground">Teklifler</div>
          <h2 className="font-heading text-3xl font-bold tracking-tight mt-1">Projeler</h2>
        </div>
        <Button data-testid="new-project-cta" onClick={() => nav("/projects/new")} className="bg-primary hover:bg-orange-600 text-white">
          <Plus size={16} className="mr-2" /> Yeni Teklif
        </Button>
      </div>

      <Card className="border-border overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-900 text-white text-left">
              <tr>
                <th className="px-4 py-2 font-semibold">Teklif No</th>
                <th className="px-4 py-2 font-semibold">Müşteri</th>
                <th className="px-4 py-2 font-semibold">Lokasyon</th>
                <th className="px-4 py-2 font-semibold">İş Türü</th>
                <th className="px-4 py-2 font-semibold">Durum</th>
                <th className="px-4 py-2 font-semibold text-right">Aksiyonlar</th>
              </tr>
            </thead>
            <tbody>
              {items.map((p) => (
                <tr key={p.id} data-testid={`project-row-${p.id}`} className="border-t border-border hover:bg-slate-50 dark:hover:bg-slate-800">
                  <td className="px-4 py-2 font-mono">{p.quote_no}</td>
                  <td className="px-4 py-2">{p.customer}</td>
                  <td className="px-4 py-2">{p.location}</td>
                  <td className="px-4 py-2">{p.job_type === 1 ? "Malzeme" : p.job_type === 2 ? "İşçilik" : "Karma"}</td>
                  <td className="px-4 py-2">
                    <span className={`px-2 py-0.5 rounded text-xs uppercase tracking-widest ${p.status === "approved" ? "bg-green-100 text-green-700" : "bg-slate-100 text-slate-700"}`}>
                      {p.status}
                    </span>
                  </td>
                  <td className="px-4 py-2 text-right space-x-1">
                    <Button size="sm" variant="ghost" onClick={() => downloadFile(p.id, "xlsx")} data-testid={`xlsx-btn-${p.id}`}>
                      <Download size={14} className="mr-1" /> XLSX
                    </Button>
                    <Button size="sm" variant="ghost" onClick={() => downloadFile(p.id, "pdf")} data-testid={`pdf-btn-${p.id}`}>
                      <FileDown size={14} className="mr-1" /> PDF
                    </Button>
                    <Button size="sm" variant="ghost" onClick={() => nav(`/projects/${p.id}`)}>Aç →</Button>
                    <Button size="sm" variant="ghost" className="text-destructive" onClick={() => del(p.id)}>Sil</Button>
                  </td>
                </tr>
              ))}
              {items.length === 0 && (
                <tr><td colSpan={6} className="px-4 py-12 text-center text-muted-foreground">Henüz proje yok. "Yeni Teklif" ile başlayın.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
